import { boolean, object, InferType, string, array, number } from 'yup';
import { UploadResponse } from '../../../../../common/src/hooks/useUpload';

export const personalizeSchema = object({
  advices: boolean().required('REQUIRED'),
  actionList: boolean().required('REQUIRED'),
  clauses: boolean().required('REQUIRED'),
  insurances: boolean().required('REQUIRED'),
  offers: boolean().required('REQUIRED'),
  benefits: boolean().required('REQUIRED'),
  saveAsDefault: boolean().required('REQUIRED'),
});

export type PersonalizeFormValues = InferType<typeof personalizeSchema>;

/**
 * ACTION LIST
 */

export const ActionListSchema = object({
  action: string().required('REQUIRED'),
  type: string().required('REQUIRED'),
  urgency: string().required('REQUIRED'),
  assigned_to_type: string().nullable(),
  completed: boolean().required('REQUIRED'),
});

export type ActionListFormValues = InferType<typeof ActionListSchema>;

/**
 * ADVICES
 */

export const AdvicesSchema = object({
  riskObjectId: string(),
  riskObject: string(),
  type: string().required('REQUIRED'),
  name: string().required('REQUIRED'),
  description: string().required('REQUIRED'),
  urgency: string().required('REQUIRED'),
  coverage: string().when('type', {
    is: 'COVERAGE',
    then: string().required('REQUIRED'),
  }),
  prevention_advice: string().notRequired(),
  alreadyInsured: boolean(),
  insuredElsewhere: boolean(),
});

export type AdvicesFormValues = InferType<typeof AdvicesSchema>;

/**
 * CLAUSES
 */

export const ClauseSchema = object({
  title: string().required('required'),
  description: string().required('required'),
  tags: array().optional(),
});

/**
 * COVERAGE
 */

export const CoverageSchema = object({
  id: string().required(),
  risk_object_id: string(),
  name: string().required('REQUIRED'),
  risk_object: string(),
  insurance_product_id: string(),
  insurance_company: string().notRequired(),
  premium: number().notRequired(),
  commission: number().notRequired().nullable(),
  commission_percentage: number().notRequired().nullable(),
  insurance_tax_percentage: number().notRequired().nullable(),
  payment_interval: string(),
  insured_value: number().notRequired(),
  deductible: string(),
});

export type CoverageFormValues = InferType<typeof CoverageSchema>;

/**
 * INSRUANCE DETAIL
 */

export const InsuranceDetailSchema = object({
  name: string().required('required'),
  closed_at_distribution: boolean(),
  premium: number().notRequired(),
  payment_interval: string(),
  coverages: array().of(CoverageSchema),
  description: string(),
  policy_nr: string(),
  start_date: string().nullable(),
  due_date: string().nullable(),
  insurance_company: string().required('REQUIRED'),
});

export interface UploadedLink {
  link: string;
  filename: string;
  description?: string;
  type?: string;
}

export type InsuranceDetailFormValues = InferType<
  typeof InsuranceDetailSchema
> & { documents: UploadResponse[]; links: UploadedLink[] };

// Needed to make 1 field optional because yup is bad
type PartialBy<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;

export type ClauseFormValues = PartialBy<
  InferType<typeof ClauseSchema>,
  'tags'
>;

/**
 * INSRUANCE PACKAGES
 */

export const PackageSchema = object({
  name: string().nullable().required('required'),
  package_nr: string().nullable().required('REQUIRED'),
  premium: number().nullable().required('REQUIRED'),
  payment_interval: string().nullable().required('REQUIRED'),
  due_date: string().nullable(),
  insurance_company: string().nullable().required('REQUIRED'),
});

export type PackageFormValues = InferType<typeof PackageSchema>;
